import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const ConfirmationDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  confirmClass,
  cancelClass,
  hideCancel = false,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="confirmation-dialog-title">
      {title && <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>}
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        {!hideCancel && (
          <Button className={cancelClass} onClick={onCancel}>
            {cancelText}
          </Button>
        )}
        <Button className={confirmClass} onClick={onConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
